<template>
  <v-main>
    <OLoadingDialog :value="isLoading" />
    <DuplicateDialog ref="duplicateDialog" />
    <ExportDialog ref="exportDialog" />
    <ImportDialog ref="importDialog" />

    <v-card>
      <v-toolbar class="card-bar">
        <v-toolbar-title>Screen Sets</v-toolbar-title>
        <v-btn icon class="ml-5" @click="reload">
          <v-icon>refresh</v-icon>
        </v-btn>
        <v-spacer />
        <v-switch
          single-line
          hide-details
          v-model="showInactive"
          label="Mostrar inativos"
        />
        <v-spacer />
        <v-btn color="primary" @click="newRow()">Novo Set...</v-btn>
        <OMenuButton :menuOpts="menuOpts" btnClass="ml-2" />
      </v-toolbar>

      <ODataTable
        :spec="spec"
        :items="rows"
        :disableInitialSort="true"
        @rowClicked="selectRow"
        :fullRowSelectable="false"
        :selectable="true"
        :selected="selectedIds"
      />
    </v-card>
  </v-main>
</template>

<script>
import { ScreenSet } from '@/models'
import { brDateTime } from 'oderon-commons/src/formatters'
import { isEmpty } from 'oderon-commons/src/utils'

let color = 'grey--text text--lighten-1',
  grey = (x) => ({ html: `<span class="${color}">${x}</span>` })

export default {
  components: {
    OLoadingDialog: require('oderon-vue/cpts/OLoadingDialog').default,
    ODataTable: require('oderon-vue/cpts/ODataTable').default,
    DuplicateDialog: require('./DuplicateDialog.vue').default,
    ExportDialog: require('./ExportDialog.vue').default,
    ImportDialog: require('./ImportDialog.vue').default
  },
  data() {
    return {
      isLoading: false,
      rows: [],
      selectedIds: [],
      showInactive: false,
      spec: [
        { t: 'ID|', d: 'id', f: grey, w: 85 },
        { t: 'Código', d: 'code' },
        { t: 'Nome', d: 'name' },
        { t: 'Aplicabilidade', d: 'appliesTo' },
        { t: 'Criado|', d: 'createdAt', f: brDateTime, w: 200 },
        { t: 'Atualizado|', d: 'updatedAt', f: brDateTime, w: 200 }
      ]
    }
  },
  computed: {
    menuOpts() {
      let len = this.selectedIds.length
      return [
        {
          text: 'Duplicar...',
          onClick: () => this.duplicate(),
          disabled: len != 1
        },
        {
          text: 'Desativar...',
          onClick: () => this.confirmDelete(),
          disabled: len != 1
        },
        { isDivider: true },
        {
          text: 'Exportar...',
          onClick: () => this.doExport(),
          disabled: len < 1
        },
        { text: 'Importar...', onClick: () => this.doImport() }
      ]
    },
    apiParams() {
      return { onlyActive: !this.showInactive }
    }
  },
  watch: {
    apiParams() {
      this.reload()
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.rows = await ScreenSet.findAll(this.apiParams)
    },

    async newRow() {
      let name = await this.$prompt({
        label: 'Nome do ScreenSet:'
      })

      if (name != null) {
        this.$loading(async () => {
          let created = await ScreenSet.save({ name })
          await this.fetchData()
          this.selectRow(created)
        })
      }
    },

    async selectRow(r) {
      this.$router.push(`/setup/screen-sets/${r.id}`)
    },

    async doExport() {
      let completeRows = await ScreenSet.findAll({ includeScreens: true })
      let rowsToExport = completeRows.filter((x) => {
        if (isEmpty(this.selectedIds)) return true
        return this.selectedIds.includes(x.id)
      })

      await this.$refs.exportDialog.open(rowsToExport)
    },

    async doImport() {
      let res = await this.$refs.importDialog.open()
      if (res != null) {
        this.$loading(async () => {
          for (let row of res) {
            await ScreenSet.save(row)
          }
          await this.fetchData()
          this.$snack('Objetos importados com sucesso')
        })
      }
    },

    async confirmDelete() {
      let row = this.rows.find((x) => x.id == this.selectedIds[0])
      let msg = `Tem certeza que deseja desativar o ScreenSet ${row.name}?`
      let res = await this.$confirmDelete(msg)
      if (res) {
        this.$loading(async () => {
          await ScreenSet.delete(row.id)
          await this.fetchData()
          this.$snack('Desativado com sucesso')
        })
      }
    },

    async duplicate() {
      let screenSetId = this.selectedIds[0]
      let res = await this.$refs.duplicateDialog.open(screenSetId)
      if (res != null) {
        this.$loading(async () => {
          let created = await ScreenSet.save(res)
          await this.fetchData()
          this.selectRow(created)
        })
      }
    }
  }
}
</script>

<style></style>
